import { css } from '@emotion/css'
import { spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  personalInfo: css({
    marginLeft: spacing.default,
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      marginTop: spacing.small,
    },
  }),

  avatar: css({
    margin: 0,
    flex: '0 0 120px',
    width: 120,
    height: 120,
    backgroundColor: colors.geyser,
  }),
}

export default styles
